import React from 'react';
import ReturnsAI from '../components/ReturnsAI/ReturnsAI';

export default function ReturnAnalytics() {
  return <ReturnsAI />;
}
